<template>
  <div>
    <v-toolbar dense flat dark>
      <v-btn
        icon
        @click="goBack()"
        style="position: absolute; left: 10px; top: 0px"
      >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title
        >Detail order #{{ orderDetail.orders_code }}</v-toolbar-title
      >
      <v-spacer />
      <v-dialog
        v-model="confirmOrderDialog"
        width="500"
        v-if="orderDetail.orders_status == 0"
      >
        <template v-slot:activator="{ on }">
          <v-btn dark color="green" :disabled="false" v-on="on"
            >ยืนยันออเดอร์</v-btn
          >
        </template>
        <v-card>
          <v-card-title class="px-5 py-4"
            ><h5 style="font-size: 23px">
              Do you want to complete this order ?
            </h5>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="px-5"
            ><h3>Are you sure to confirm this order</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions style="justify-content: flex-end">
            <v-btn
              color="error"
              flat
              @click="
                () => {
                  confirmOrderDialog = false;
                }
              "
              >Back</v-btn
            >
            <v-btn
              color="success"
              flat
              @click="confirm_Order(orderDetail.orders_code)"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="completingOrderDialog" width="500" v-else>
        <template v-slot:activator="{ on }">
          <v-btn dark color="green" :disabled="true" v-on="on">จบงาน</v-btn>
          <!-- :disabled="isNewOrderOrProcess" -->
        </template>
        <v-card>
          <v-card-title class="pa-5"
            ><h3>Do you want to complete this order ?</h3>
          </v-card-title>
          <v-divider></v-divider>
          <!-- <v-card-text>
            <p>Please upload image</p>
            <div>
              <input
                type="file"
                accept="image/*"
                @change="onSelectCompletingOrderImage"
              />
            </div>
          </v-card-text> -->
          <v-divider></v-divider>
          <v-card-actions style="justify-content: flex-end">
            <v-btn color="error" flat @click="closeCompletingOrderDialog()"
              >Back</v-btn
            >
            <v-btn
              color="success"
              flat
              @click="
                {
                  {
                    orderDetail.orders_provider_company_id != null
                      ? completeProvider()
                      : completeWeSmart();
                  }
                }
              "
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="cancel_OrderDialog"
        width="500"
        v-if="orderDetail.orders_status == 0"
      >
        <template v-slot:activator="{ on }" v-on="on">
          <v-btn dark color="red" @click="cancel_OrderDialog = true"
            >ยกเลิกออเดอร์</v-btn
          >
        </template>

        <v-card>
          <v-card-title class="px-5 py-4"
            ><h5 style="font-size: 23px">Do you want to cancel this order ?</h5>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-title class="px-5"
            ><h3>Are you sure to cancel this order</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions style="justify-content: flex-end">
            <v-btn color="error" flat @click="cancel_OrderDialog = false"
              >Back</v-btn
            >
            <v-btn
              color="success"
              flat
              @click="
                {
                  {
                    orderDetail.orders_provider_company_id != null
                      ? cancelWesmartOrderProvider()
                      : cancelWesmartOrder();
                  }
                }
              "
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="cancelOrderDialog" width="500" v-else>
        <template v-slot:activator="{ on }">
          <v-btn dark color="red" :disabled="isNewOrderOrProcess" v-on="on"
            >ยกเลิกออเดอร์</v-btn
          >
        </template>

        <v-card>
          <v-card-title>
            <h3>Do you want to cancel this Order?</h3></v-card-title
          >
          <v-divider></v-divider>
          <v-card-text>
            <p>Are you sure to cancel this order</p>
          </v-card-text>
          <v-divider />
          <v-card-actions style="justify-content: flex-end">
            <v-btn color="error" flat @click="closeCancelOrderDialog()"
              >Back</v-btn
            >
            <v-btn
              color="success"
              flat
              @click="
                {
                  {
                    orderDetail.orders_provider_company_id != null
                      ? cancelWesmartOrderProvider()
                      : cancelWesmartOrder();
                  }
                }
              "
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="isLoading" width="200" persistent>
        <template v-slot:activator="{ on }" v-on="on"> </template>
        <v-card
          dark
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 40px;
          "
        >
          <div class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          Loading
        </v-card>
      </v-dialog>

      <v-dialog v-model="selectRiderDialog" width="500">
        <template v-slot:activator="{ on }" v-on="on"> </template>
        <v-card>
          <v-card-title
            ><h3 v-if="selectedRider.or_users_id">
              Select
              <span style="color: grey"
                >{{ selectedRider.or_users_id.users_name }}
              </span>
              for this order ?
            </h3></v-card-title
          >
          <v-divider />
          <v-card-text>
            <p style="margin: 20px 0px">
              System will be select this rider and cancel all rider in this
              order.
            </p>
          </v-card-text>
          <v-divider />
          <v-card-actions style="justify-content: flex-end">
            <v-btn flat @click="selectRiderDialog = false" color="error"
              >Back</v-btn
            >
            <v-btn color="success" flat @click="selectRider">Select</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <div style="margin-top: 20px">
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <v-card elevation="0" style="padding-bottom: 20px">
            <v-card-title class="section-topic">Customer & Order</v-card-title>
            <div style="font-size: 14px; padding: 1.5rem">
              <div>
                <b>Customer Name</b> :
                {{
                  orderDetail.orders_customer_name ||
                  orderDetail.orders_business_name
                }}
                | Tel No. :
                {{
                  orderDetail.orders_customer_phone ||
                  orderDetail.orders_business_phone
                }}
              </div>
            </div>

            <v-card-title style="font-size: 1.25rem; font-weight: 600"
              >Order Detail</v-card-title
            >
            <div
              style="
                font-size: 16px;
                padding: 20px;
                margin: 0px 20px;
                border-style: solid;
                border-radius: 20px;
                border-color: lightgrey;
              "
            >
              <!-- <v-divider /> -->

              <div id="order-summary">
                <div
                  style="padding: 10px; display: flex; flex-direction: column"
                >
                  <v-layout class="mt-2">
                    <v-flex>Payment type</v-flex>
                    <v-flex style="text-align: right">
                      {{
                        orderDetail.orders_payt_id == 1
                          ? "Cash on Delivery"
                          : orderDetail.orders_payt_id == 2
                          ? "Credit/Debit Card"
                          : orderDetail.orders_payt_id == 3
                          ? "PromptPay"
                          : orderDetail.orders_payt_id == 4
                          ? "Cyptocurrency"
                          : orderDetail.orders_payt_id == 5
                          ? "Account Receivable"
                          : "Other"
                      }}
                    </v-flex>
                  </v-layout>
                  <v-layout class="mt-2" v-if="orderDetail.order_status == 1">
                    <v-flex>Cashflow method</v-flex>
                    <v-flex style="text-align: right">
                      {{
                        orderDetail.orders_payment_method == 2
                          ? "Pay at store"
                          : orderDetail.orders_payment_method == 3
                          ? "Pay at store (Partner)"
                          : "Auto transfer"
                      }}
                    </v-flex>
                  </v-layout>
                  <v-layout class="mt-2">
                    <v-flex>Total Product Price</v-flex>
                    <v-flex style="text-align: right"
                      >{{ orderDetail.orders_product_total_price }} ฿</v-flex
                    >
                  </v-layout>
                  <v-layout class="mt-2">
                    <v-flex>Small Order Difference Price</v-flex>
                    <v-flex style="text-align: right"
                      >{{
                        orderDetail.orders_small_order_difference || 0
                      }}
                      ฿</v-flex
                    >
                  </v-layout>
                  <v-layout class="mt-2">
                    <v-flex>Order Extra Price</v-flex>
                    <v-flex style="text-align: right"
                      >{{ orderDetail.orders_extra_price }} ฿</v-flex
                    >
                  </v-layout>

                  <v-layout class="mt-2">
                    <v-flex>Package Store Transport Price</v-flex>
                    <v-flex style="text-align: right">
                      {{
                        orderDetail.orders_package_extra_transport_price == null
                          ? 0
                          : orderDetail.orders_package_extra_transport_price
                      }}
                      ฿
                    </v-flex>
                  </v-layout>

                  <v-layout class="mt-2">
                    <v-flex>Discount</v-flex>
                    <v-flex style="text-align: right"
                      >{{ orderDetail.orders_promotion_discount }} ฿</v-flex
                    >
                  </v-layout>

                  <!-- <v-layout>
                    <v-flex>Order Include Fee</v-flex>
                    <v-flex style="text-align: right"
                      >{{ orderDetail.orders_include_fee_price }} ฿</v-flex
                    >
                  </v-layout> -->

                  <v-layout class="mt-2">
                    <v-flex>Service Charge</v-flex>
                    <v-flex style="text-align: right"
                      >{{ orderDetail.orders_service_charge_price }} ฿</v-flex
                    >
                  </v-layout>

                  <v-layout class="mt-2">
                    <v-flex>VAT</v-flex>
                    <v-flex style="text-align: right"
                      >{{ orderDetail.orders_vat_price }} ฿</v-flex
                    >
                  </v-layout>
                  <v-layout class="mt-2">
                    <v-flex><b>Order Total Price</b></v-flex>
                    <v-flex style="text-align: right"
                      ><b>{{ orderDetail.orders_total_price.toFixed(2) }} ฿</b>
                    </v-flex>
                  </v-layout>
                </div>
                <v-divider />
              </div>
              <div class="total-price">
                <div>
                  <v-layout class="mt-2">
                    <v-flex
                      ><b
                        >Delivery Price
                        <span style="color: orange"
                          >(Include Guarantee Fee)</span
                        ></b
                      ></v-flex
                    >
                    <v-flex style="text-align: right"
                      >{{ orderDetail.orders_transfer_price }} ฿</v-flex
                    >
                  </v-layout>
                  <v-layout class="mt-2">
                    <v-flex style="color: red"><b>Order Fee</b></v-flex>
                    <v-flex style="color: red; text-align: right"
                      >{{ orderDetail.orders_fee_price.toFixed(2) }} ฿</v-flex
                    >
                  </v-layout>
                  <!-- <v-layout justify-space-between class="mt-2">
                    <v-flex style="color: green"><b
                      > Order Include Fee</b
                      > </v-flex>
                    <v-flex style="text-align: right; color: green">
                      {{ orderDetail.orders_include_fee_price.toFixed(2) }} ฿
                    </v-flex>
                  </v-layout> -->
                  <v-layout justify-space-between class="mt-2">
                    <v-flex style="color: green"><b> Order Income</b> </v-flex>
                    <v-flex style="text-align: right; color: green">
                      {{
                        (
                          orderDetail.orders_transfer_price -
                          orderDetail.orders_fee_price
                        ).toFixed(2)
                      }}
                      ฿
                    </v-flex>
                  </v-layout>
                </div>
              </div>
              <v-divider />

              <div style="padding: 10px">
                <v-layout column>
                  <v-flex><b>Order Note</b></v-flex>
                  <v-flex
                    style="padding-left: 20px"
                    v-if="orderDetail.orders_note"
                    >{{ orderDetail.orders_note }}</v-flex
                  >
                  <v-flex style="padding-left: 20px" v-else>-</v-flex>
                  <v-flex><b>Order Remark</b></v-flex>
                  <v-flex
                    style="padding-left: 20px"
                    v-if="orderDetail.orders_remark"
                    >{{ orderDetail.orders_remark }}</v-flex
                  >
                  <v-flex style="padding-left: 20px" v-else>-</v-flex>
                </v-layout>
              </div>
            </div>
            <v-card-title style="font-size: 1.25rem; font-weight: 600"
              >Rider Detail</v-card-title
            >

            <div
              style="
                font-size: 16px;
                padding: 20px;
                margin: 0px 20px;
                border-style: solid;
                border-radius: 20px;
                border-color: lightgrey;
              "
              v-if="orderDetail.order_rider.length > 0"
            >
              <div
                v-for="(item, index) in orderDetail.order_rider"
                :key="index"
                class="my-2"
              >
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div>
                    {{ item.or_users_id.users_name }}
                  </div>

                  <div :style="renderStatusColor(item.or_status)">
                    {{ setStatus(item.or_status) }}

                    <v-btn
                      small
                      v-if="haveRidersOnProcess && item.or_status != 4"
                      style="color: white"
                      color="green"
                      @click="setCurrentRider(item)"
                      >Select</v-btn
                    >
                  </div>
                </div>
              </div>
              <label for="" style="color: red" v-if="haveRidersOnProcess"
                >*Please select a rider for cancel other rider</label
              >
            </div>
            <div v-else style="font-size: 14px; padding: 0px 2rem">
              No Rider Now
            </div>
            <!-- <div style="font-size: 14px; padding: 0px 2rem">
              <v-card
                elevation="0"
                style="border:  solid #00000029; border-radius: 20px;"
              >
                <div v-for="(item, index) in rider_detail" :key="index">
                  <v-layout row wrap class="pa-2">
                    <v-flex align-self-center xs12 sm6 lg5 class="d-flex mr-4">
                      <div
                        v-if="orderDetail.order_rider.length"
                        style="margin-top: 12px; overflow-wrap: break-word;"
                      >
                        {{ item.or_users_id.users_first_name
                        }}<span class="ml-1">{{
                          item.or_users_id.users_last_name
                        }}</span>
                      </div>
                      <div v-else>No Rider Now</div>
                      <v-btn
                        v-if="orderDetail.order_rider.length"
                        class="info--text"
                        outline
                        style="border: 1px solid #008FFD; border-radius: 5px; width: 15%;font-size: 12px;"
                        >{{
                          item.or_status == 2
                            ? "ON PROCESS"
                            : item.or_status == 3
                            ? "Completed"
                            : null
                        }}</v-btn
                      >
                    </v-flex>
                    <v-flex xs12 sm12 lg6 align-self-center class="d-flex">
                      <v-dialog v-model="dialogClear" width="550">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :disabled="item.or_status == 3"
                            v-if="orderDetail.order_rider.length"
                            dark
                            v-on="on"
                            class="red--text pa-1"
                            outline
                            :style="
                              item.or_status == 3
                                ? null
                                : 'border: 1px solid red; border-radius: 5px;width: 50%; font-size: 12px;'
                            "
                            ><v-icon size="18">mdi-close-circle-outline</v-icon>
                            <p class="ml-3">
                              Clear
                            </p>
                            Rider</v-btn
                          >
                        </template>

                        <v-card class="pa-3">
                          <v-card-title
                            style="font-size: 30px; font-weight: bold;"
                            >Confirm your action</v-card-title
                          >
                          <v-card-text style="color: #90A4AE; font-size: 15px;"
                            >Do you want to remove this rider from this
                            order?</v-card-text
                          >
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              dark
                              @click="dialogClear = false"
                              class="red--text"
                              outline
                              style="border: 1px solid red; border-radius: 5px; "
                              >Cancel</v-btn
                            >
                            <v-btn
                              color="red"
                              @click="remove(index, item)"
                              class="white--text"
                            >
                              Remove
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogSelectRider" width="550">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :disabled="item.or_status == 3"
                            class="pa-1"
                            style="width: 50%; font-size: 12px;"
                            color="info"
                            dark
                            v-on="on"
                            ><v-icon size="18">mdi-moped</v-icon>
                            <p class="ml-3">Select</p>
                            Rider</v-btn
                          >
                        </template>

                        <v-card>
                          <v-card-title
                            class="black white--text"
                            style="font-size: 25px;"
                            :style="{
                              height:
                                $vuetify.breakpoint.sm || $vuetify.breakpoint.xs
                                  ? '70px'
                                  : '80px',
                              fontSize:
                                $vuetify.breakpoint.sm || $vuetify.breakpoint.xs
                                  ? '22px'
                                  : '25px',
                            }"
                          >
                            Select Rider
                            <v-spacer></v-spacer
                            ><v-btn
                              large
                              flat
                              icon
                              color="white"
                              @click="dialogSelectRider = false"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-container>
                            <v-text-field
                              color="black"
                              outline
                              label="Search Rider"
                              v-model="fillterRider"
                              prepend-inner-icon="mdi-magnify"
                            >
                            </v-text-field>
                          </v-container>

                          <v-card-text style="height: 430px;overflow: auto;">
                            <v-layout row wrap class="pa-1">
                              <v-flex sm4>No.</v-flex>
                              <v-flex sm8 xs10>Rider Name</v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <v-hover
                              v-for="(item, index) in filteredRider"
                              :key="index"
                            >
                              <div
                                slot-scope="{ hover }"
                                :style="{
                                  backgroundColor: hover ? '#FFF7BC' : 'white',
                                }"
                              >
                                <v-layout class="pa-1" row wrap>
                                  <v-flex sm4 xs3 class="my-3">{{
                                    item.rider_id
                                  }}</v-flex>
                                  <v-flex sm5 xs4 class="my-3"
                                    ><div
                                      :style="{
                                        width:
                                          $vuetify.breakpoint.sm ||
                                          $vuetify.breakpoint.xs
                                            ? '100px'
                                            : null,
                                      }"
                                      style="overflow-wrap: break-word;"
                                    >
                                      {{ item.rider_full_name }}
                                    </div></v-flex
                                  ><v-flex sm3 xs5
                                    ><v-btn
                                      :id="item.rider_id"
                                      :block="
                                        $vuetify.breakpoint.sm == false ||
                                          $vuetify.breakpoint.xs == false
                                      "
                                      @click="select_rider(item)"
                                      style="border: 2px solid #FFD600;  border-radius: 5px"
                                      :style="{
                                        backgroundColor: hover
                                          ? '#FDDF00'
                                          : '#FFF7BC',
                                      }"
                                      ><p class="black--text">
                                        Select
                                      </p></v-btn
                                    ></v-flex
                                  ></v-layout
                                >
                                <v-divider></v-divider>
                              </div>
                            </v-hover>
                            <div
                              v-if="loading_rider"
                              style="
                                            display: flex;
                                          justify-content: center;
                                          align-items: center;
                                          height: 300px;

                                                
                                                "
                            >
                              <v-progress-circular
                                indeterminate
                                color="primary"
                              ></v-progress-circular>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </v-flex>
                  </v-layout>
                </div>
                <div v-if="rider_detail.length == 0">
                  <v-layout row wrap class="pa-2">
                    <v-flex sm8 xs12 lg3 align-self-center>No Rider Now</v-flex>
                    <v-flex sm12 xs12 lg8 align-self-center
                      ><template>
                        <div class="text-lg-right text-xs-center">
                          <v-dialog v-model="dialogSelectRider" width="550">
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="pa-1"
                                style="width: 50%; font-size: 12px;"
                                color="info"
                                dark
                                v-on="on"
                                ><v-icon size="18">mdi-moped</v-icon>
                                <p class="ml-3">Select</p>
                                Rider</v-btn
                              >
                            </template>

                            <v-card>
                              <v-card-title
                                class="black white--text"
                                style="font-size: 25px;"
                                :style="{
                                  height:
                                    $vuetify.breakpoint.sm ||
                                    $vuetify.breakpoint.xs
                                      ? '70px'
                                      : '80px',
                                  fontSize:
                                    $vuetify.breakpoint.sm ||
                                    $vuetify.breakpoint.xs
                                      ? '22px'
                                      : '25px',
                                }"
                              >
                                Select Rider
                                <v-spacer></v-spacer
                                ><v-btn
                                  large
                                  flat
                                  icon
                                  color="white"
                                  @click="dialogSelectRider = false"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </v-card-title>
                              <v-container>
                                <v-text-field
                                  color="black"
                                  outline
                                  label="Search Rider"
                                  v-model="fillterRider"
                                  prepend-inner-icon="mdi-magnify"
                                >
                                </v-text-field>
                              </v-container>

                              <v-card-text
                                style="height: 430px;overflow: auto;"
                              >
                                <v-layout row wrap class="pa-1">
                                  <v-flex sm4>No.</v-flex>
                                  <v-flex sm8 xs10>Rider Name</v-flex>
                                </v-layout>
                                <v-divider></v-divider>
                                <v-hover
                                  v-for="(item, index) in filteredRider"
                                  :key="index"
                                >
                                  <div
                                    slot-scope="{ hover }"
                                    :style="{
                                      backgroundColor: hover
                                        ? '#FFF7BC'
                                        : 'white',
                                    }"
                                  >
                                    <v-layout class="pa-1" row wrap>
                                      <v-flex sm4 xs3 class="my-3">{{
                                        item.rider_id
                                      }}</v-flex>
                                      <v-flex sm5 xs4 class="my-3"
                                        ><div
                                          :style="{
                                            width:
                                              $vuetify.breakpoint.sm ||
                                              $vuetify.breakpoint.xs
                                                ? '100px'
                                                : null,
                                          }"
                                          style="overflow-wrap: break-word;"
                                        >
                                          {{ item.rider_full_name }}
                                        </div></v-flex
                                      ><v-flex sm3 xs5
                                        ><v-btn
                                          :id="item.rider_id"
                                          :block="
                                            $vuetify.breakpoint.sm == false ||
                                              $vuetify.breakpoint.xs == false
                                          "
                                          @click="select_rider(item)"
                                          style="border: 2px solid #FFD600;  border-radius: 5px"
                                          :style="{
                                            backgroundColor: hover
                                              ? '#FDDF00'
                                              : '#FFF7BC',
                                          }"
                                          ><p class="black--text">
                                            Select
                                          </p></v-btn
                                        ></v-flex
                                      ></v-layout
                                    >
                                    <v-divider></v-divider>
                                  </div>
                                </v-hover>
                                <div
                                  v-if="loading_rider"
                                  style="
     display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;

         
        "
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="primary"
                                  ></v-progress-circular>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-dialog>
                        </div> </template
                    ></v-flex>
                  </v-layout>
                </div>
              </v-card>
            </div> -->
          </v-card>
          <v-card elevation="0">
            <v-card-title class="section-topic">Promotion</v-card-title>
            <div
              style="
                font-size: 16px;
                padding: 20px;
                margin: 20px 20px;
                border-style: solid;
                border-radius: 20px;
                border-color: lightgrey;
              "
            >
              <v-layout column>
                <v-layout>
                  <v-flex><b>Promotion Code</b></v-flex>

                  <div style="text-align: right">
                    <v-flex
                      v-if="orderDetail.orders_promotion_code"
                      style="color: grey"
                      >{{ orderDetail.orders_promotion_code }}</v-flex
                    >
                    <v-flex v-else>-</v-flex>
                  </div>
                </v-layout>
                <v-layout>
                  <v-flex><b>Promotion Name</b></v-flex>
                  <div>
                    <v-flex
                      v-if="orderDetail.orders_promotion_name"
                      style="color: grey"
                      >{{ orderDetail.orders_promotion_name }}</v-flex
                    >
                    <v-flex v-else>-</v-flex>
                  </div>
                </v-layout>
                <v-layout
                  ><v-flex><b>Promotion Discount</b></v-flex>

                  <div style="text-align: right">
                    <v-flex
                      v-if="orderDetail.orders_promotion_discount"
                      style="color: grey"
                      >{{ orderDetail.orders_promotion_discount }}</v-flex
                    >
                    <v-flex v-else>-</v-flex>
                  </div>
                </v-layout>
              </v-layout>
              <p></p>
            </div>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6>
          <v-card elevation="0" style="margin-left: 10px">
            <v-card-title class="section-topic">Location</v-card-title>
            <div>
              <div
                style="
                  background-color: lightgrey;
                  padding: 1.5rem 1rem;
                  margin: 0.5rem;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                "
              >
                <div>
                  Start : {{ orderDetail.orders_zone_start }} ,
                  {{ orderDetail.orders_place_start }}
                </div>
                <div>
                  End : {{ orderDetail.orders_zone_end }} ,
                  {{ orderDetail.orders_place_end }}
                </div>
              </div>

              <div
                style="padding: 1rem"
                id="order_points"
                v-for="(point, index) in orderDetail.order_point"
                :key="index"
              >
                <p class="points-topic">Point {{ index + 1 }}</p>

                <v-card style="padding: 2rem 1.25rem" elevation="1">
                  <div>
                    <p>{{ point.opt_place }} : {{ point.opt_address }}</p>
                    <p>Tel. : {{ point.opt_mobile1 }}</p>
                    <p>Latitude : {{ point.opt_latitude }}</p>
                    <p>Longitude : {{ point.opt_longitude }}</p>
                    <p>E-Mail : {{ point.opt_email }}</p>
                  </div>
                </v-card>
              </div>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      selectedRider: {},
      riders: [
        {
          or_orders_id: 39140,
          or_status: "2",
          or_users_id: {
            users_id: 114,
            users_name: "thanantron jittrapirom",
            users_first_name: "thanantron",
            users_last_name: "jittrapirom",
            users_email: "thanantron@gmail.com",
            users_phone: "0845451345",
          },
        },
        {
          or_orders_id: 39140,
          or_status: "2",
          or_users_id: {
            users_id: 124,
            users_name: "qqqqqqq wwwwwww",
            users_first_name: "thanantron",
            users_last_name: "jittrapirom",
            users_email: "thanantron@gmail.com",
            users_phone: "0845451345",
          },
        },
        {
          or_orders_id: 39143,
          or_status: "2",
          or_users_id: {
            users_id: 122,
            users_name: "qqqqqqq wwwwwww",
            users_first_name: "thanantron",
            users_last_name: "jittrapirom",
            users_email: "thanantron@gmail.com",
            users_phone: "0845451345",
          },
        },
        {
          or_orders_id: 39140,
          or_status: "2",
          or_users_id: {
            users_id: 216,
            users_name: "ณัฐพงษ์ เกตุเมือง",
            users_first_name: "thanantron",
            users_last_name: "jittrapirom",
            users_email: "thanantron@gmail.com",
            users_phone: "0845451345",
          },
        },
      ],
      snackbar: false,
      dialogSelectRider: false,
      dialogClear: false,
      loading_rider: false,
      loading_clear: false,
      select_loading: false,
      rider_detail: [],
      fillterRider: "",
      nameRider: "",
      snackbarText: "",
      timeout: 2000,
      isLoading: false,
      isCompleteOrCandelled: false,
      orderDetail: {
        orders_total_price: 0,
        orders_fee_price: 0,
        orders_include_fee_price: 0,
        order_rider: [],
      },
      cancelOrderDialog: false,
      completingOrderDialog: false,
      selectRiderDialog: false,
      riderAssignDialog: false,
      selectedImage: "",
      confirmOrderDialog: false,
      cancel_OrderDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    ...mapState({
      fetchRiderListData: (state) =>
        state.fetchOrderDetailBack.fetchRiderListData,
    }),
    isNewOrderOrProcess() {
      if (
        this.orderDetail.orders_status == 1 ||
        this.orderDetail.orders_status == 2
      ) {
        return false;
      } else {
        return true;
      }
    },
    haveRidersOnProcess() {
      return this.orderDetail.order_rider.some((value) => value.or_status != 4);
    },
    filteredRider() {
      return this.fetchRiderListData.filter(
        (val) =>
          val.rider_full_name
            .toLowerCase()
            .includes(this.fillterRider.toLowerCase()) ||
          String(val.rider_id)
            .toLowerCase()
            .includes(this.fillterRider.toLowerCase())
      );
    },
  },
  watch: {
    dialogSelectRider() {
      if (this.dialogSelectRider == true) {
        this.fillterRider = "";
        this.getRiderlist();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchOrderDetail: "fetchOrderDetailBack/fetchOrderWesmartDetailById",
      wesmartCancelOrder: "fetchOrderDetailBack/wesmartCancelOrderByOrderCode",
      wesmartCompleteOrderByOrderCode:
        "fetchOrderDetailBack/wesmartCompleteOrderByOrderCode",
      wesmartSelectRider: "fetchOrderDetailBack/wesmartSelectRider",
      sendOrderAndRiderIdToWesmart:
        "fetchOrderDetailBack/sendOrderAndRiderIdToWesmart",
      fetchRiderList: "fetchOrderDetailBack/fetchRiderList",
      sentOrderToRider: "fetchOrderDetailBack/sentOrderToRider",
      ClearRiderinOrder: "fetchOrderDetailBack/ClearRiderinOrder",
      completeOrderProviderWesmart:
        "fetchOrderDetailBack/completeOrderProviderWesmart",
      cancelOrderProviderWesmart:
        "fetchOrderDetailBack/cancelOrderProviderWesmart",
      InqueueOrderProvider: "fetchOrderDetailBack/InqueueOrderProvider",
    }),
    isRiderNewOrderOrProcess(status) {
      if (
        status == "3" ||
        status == "4" ||
        this.orderDetail.orders_status == 3 ||
        this.orderDetail.orders_status == 4
      ) {
        return true;
      } else {
        return false;
      }
    },
    async select_rider(item) {
      this.isLoading = true;
      let body = {
        order_id: Number(this.$route.params.id),
        rider_id: item.rider_id,
      };
      let res = await this.sentOrderToRider(body);
      if (res == false) return;
      this.rider_detail.push({
        or_orders_id: res.or_orders_id,
        or_status: res.or_status,
        or_users_id: {
          id: res.or_user_id.id,
          users_id: res.or_user_id.users_email,
          users_name: res.or_user_id.users_first_name,
          users_first_name: res.or_user_id.users_id,
          users_last_name: res.or_user_id.users_last_name,
          users_email: res.or_user_id.users_name,
          users_phone: res.or_user_id.users_phone,
        },
      });
      this.fetchData();
      this.dialogClear = false;
      this.isLoading = false;
      this.dialogSelectRider = false;
    },
    async remove(index, item) {
      this.loading_clear = true;
      let res = await this.ClearRiderinOrder(this.$route.params.id);
      if (res == false) return;
      this.rider_detail.splice(index, 1);
      this.loading_clear = false;
    },
    async confirm_Order(item) {
      let res = await this.InqueueOrderProvider(item);
      if (res == false) return;
      this.goBack();
      this.confirmOrderDialog = false;
    },
    async completeProvider() {
      this.isLoading = true;
      let res = await this.completeOrderProviderWesmart(this.$route.params.id);
      if (res == false) return;
      this.completingOrderDialog = false;
      this.isLoading = false;
    },
    async cancelWesmartOrderProvider() {
      this.isLoading = true;
      let res = await this.cancelOrderProviderWesmart(this.$route.params.id);
      if (res == false) return;
      this.isLoading = false;
      this.cancelOrderDialog = false;
      this.cancel_OrderDialog = false;
      this.goBack();
    },
    async getRiderlist() {
      this.loading_rider = true;
      await this.fetchRiderList();
      this.loading_rider = false;
    },
    setStatus(status) {
      switch (status) {
        case "1":
          return "New Order";
          break;

        case "2":
          return "On Process";
          break;
        case "3":
          return "Complete";
          break;
        case "4":
          return "Cancelled";
          break;
        default:
          return "Error";
          break;
      }
    },
    renderStatusColor(status) {
      switch (status) {
        case "1":
          return { color: "black", fontWeight: "600" };
          break;

        case "2":
          return { color: "orange", fontWeight: "600" };
          break;
        case "3":
          return { color: "green", fontWeight: "600" };
          break;
        case "4":
          return { color: "red", fontWeight: "600" };
          break;
        default:
          return "Error";
          break;
      }
    },
    setCurrentRider(payload) {
      this.selectedRider = payload;
      this.selectRiderDialog = true;
    },
    closeCancelOrderDialog() {
      this.cancelOrderDialog = false;
    },

    closeCompletingOrderDialog() {
      this.selectedImage = "";
      this.completingOrderDialog = false;
    },

    onSelectCompletingOrderImage(event) {
      const selectedImage = event.target.files[0];
      // convert function
      this.convertToBase64(selectedImage);
    },

    convertToBase64(fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImage = e.target.result;
      };
      reader.readAsBinaryString(fileObject);
    },
    goBack() {
      this.$router.back();
    },

    async cancelWesmartOrder() {
      let payload = {
        orderCode: this.orderDetail.orders_code,
        province: this.$route.params.province,
        orderStatus: this.orderDetail.orders_status,
      };
      this.isLoading = true;
      let response = await this.wesmartCancelOrder(payload);
      // console.log("cancel", response);
      if (response) {
        this.snackbarText = "Order has been cancelled";
        this.snackbar = true;
        this.isLoading = false;
        setTimeout(() => this.goBack(), 500);
      } else {
        this.snackbarText = "Order has not cancelled";
        this.snackbar = true;
        this.isLoading = false;
      }
    },

    async fetchData() {
      let payload = {
        orderId: this.$route.params.id,
        province: this.$route.params.province,
      };
      this.isLoading = true;
      this.orderDetail = await this.fetchOrderDetail(payload);
      this.rider_detail = this.orderDetail.order_rider.filter(
        (word) => word.or_status == 2 || word.or_status == 3
      );
      this.isLoading = false;
    },
    async completeWeSmart() {
      // console.log("image", this.selectedImage.length);
      // console.log("order detail order id", this.orderDetail.orders_id);
      if (this.selectedImage.length > 0) {
        let payload = {
          province: this.$route.params.province,
          order_code: this.orderDetail.orders_code,
          order_id: this.orderDetail.orders_id,
          img: this.selectedImage, // convert to base64
        };
        this.isLoading = true;
        let response = await this.wesmartCompleteOrderByOrderCode(payload);
        if (response.msg) {
          this.snackbarText = "Order has been completed";
          this.snackbar = true;
          setTimeout(() => this.goBack(), 500);
          this.isLoading = false;
        } else {
          this.snackbarText = "Order has not completed";
          this.snackbar = true;
          this.isLoading = false;
        }
      } else {
        return false;
      }
    },
    changeStatusExceptSelf() {
      let currentIndex = this.orderDetail.order_rider.findIndex(
        (item) => item === this.selectedRider
      );
      let newArray = this.orderDetail.order_rider.map((rider, idx) =>
        idx === currentIndex
          ? rider
          : {
              or_orders_id: rider.or_orders_id,
              or_status: "4",
              or_users_id: {
                users_id: rider.or_users_id.users_id,
                users_name: rider.or_users_id.users_name,
                users_first_name: rider.or_users_id.users_first_name,
                users_last_name: rider.or_users_id.users_last_name,
                users_email: rider.or_users_id.users_email,
                users_phone: rider.or_users_id.users_phone,
              },
            }
      );
      this.orderDetail.order_rider = newArray;
    },
    async selectRider() {
      this.selectRiderDialog = false;
      this.isLoading = true;
      let res = await this.wesmartSelectRider({
        province: this.$route.params.province,
        riderId: this.selectedRider.or_users_id.id,
        orderCode: this.orderDetail.orders_code,
      });

      if (res.msg) {
        this.changeStatusExceptSelf();
        this.snackbarText = "Rider has been revoke";
        this.isLoading = false;
        this.snackbar = true;
      } else {
        this.snackbarText = "Failed to Revoke Eider";
        this.snackbar = true;
      }
    },

    async wesmartSendOrderAndRiderIdToWesmart() {
      await this.wesmartSendOrderAndRiderIdToWesmart({
        province: this.$route.params.province,
        riderId: this.selectedRider.or_users_id.users_id,
        orderCode: this.orderDetail.orders_code,
      });
    },
  },

  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
p {
  margin: 5px;
}
.section-topic {
  background-color: #f9d749;
  font-weight: 600;
  font-size: 1.5rem;
  letter-spacing: 0.35px;
}
.points-topic {
  background-color: #f9d749;
  width: fit-content;
  padding: 0.25rem 1rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 20px;
  letter-spacing: 0.35px;
  margin-bottom: 20px;
}
.total-price {
  /* background-color: #f9d749; */
  font-size: 1.25rem;
  font-weight: 600;
  /* text-align: center; */
  padding: 10px;
  margin: 20px 0px;
}

.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
